import { PolicyUi } from '@/common/Policy';
import Auth from '@/services/Auth';
import PolicyService from '@/services/Policy';
import store from '@/store';

/**
 * Each time the user navigates to a new route, this function is invoked to possibly update the
 * policies. This is for the rare case that a user has just signed up, and the policy data that was
 * initially fetched for that user was not yet complete (see the comments on `IncompletePolicy`).
 *
 * This is a workaround! Ideally, the backend should send a websocket notification once
 * policy data is ready.
 */
export default async (): Promise<void> => {
	if (Auth.checkPermission('VIEW_POLICY_INFO')) {
		const policies: PolicyUi[] = store.getters['Policy/policies'];
		const shouldUpdatePolicies: boolean =
			policies.length === 0 ||
			policies.some((policy: PolicyUi): boolean => !PolicyService.isCompletePolicy(policy));
		if (shouldUpdatePolicies) {
			await PolicyService.setPolicyData();
		}
	}
};
